import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader } from "../Helpers";
import {
  STR_DOCTORS_2,
  STR_MENU_DOCTORS,
  STR_NO_DOCTORS,
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import OneDoctor from '../ones/OneDoctor';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getAllDoctors();
    setReady(true);
  }



  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <h6 className="mSectionTitle">
            {STR_DOCTORS_2[appContext.language]}
          </h6>

          <div className="row">
            {
              (appContext.allDoctors && appContext.allDoctors.length > 0) ?
                appContext.allDoctors.map((item, i) => {
                  return (
                    <div key={i} className="col-md-4">
                      <OneDoctor data={item} />
                    </div>
                  )
                })
                :
                <div className="col-md-12">
                  <h6
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {STR_NO_DOCTORS[appContext.language]}
                  </h6>
                </div>
            }
          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}